/**
 * Route protégée : nécessite une session valide (vérifiée côté serveur via /api/auth/me).
 * Pattern à 3 états (null = vérification en cours, true/false = résultat).
 */
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Si l'utilisateur vient d'être authentifié via AuthCallback, on évite un aller-retour serveur
  if (location.state?.user) {
    return children ?? <Outlet />;
  }

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#F4F6F8]">
        <div className="text-sm text-slate-500">Chargement du cockpit...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children ?? <Outlet />;
}
